module.exports = __webpack_public_path__ + "static/media/HRECOS_Stations_Beczak.3a2d8a63.jpg";